// 不想显示考勤弹框的黑名单在这里配置。会正则使用这里面的每一项去匹配path.
export default [
  'ktpCourse',
  'ktpMy',
  'ktpInfo',
  'login',
  'ktpMessage',
  'todoList',
  'joinCourse',
  'myAllSetting',
  'teachingAndResearchOffice',
  'teachingMain'
]
